/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const NetworkEnum = {
    GET_INTERFACE_ALL: '/interfaces',
    GET_INTERFACE: (id: string): string => {
        return '/interfaces/' + id;
    },
    PUT_INTERFACE: (id: string): string => {
        return '/interfaces/' + id;
    },
    POST_VLAN_ADD: '/interfaces',
    POST_BOND_ADD: '/interfaces',
    PUT_MTU: '/network/mtu',
    PUT_OFFLOAD: '/network/offload',
    PUT_VLAN: (vlanId: string): string => {
        return '/interfaces/' + vlanId;
    },
    DELETE_VLAN: (vlanId: string): string => {
        return '/interfaces/' + vlanId;
    },
    DELETE_BOND: (iface: string): string => {
        return '/interfaces/' + iface;
    },
    PUT_INTERFACE_GROUP: (ifaceId: string): string => {
        return '/interfaces/' + ifaceId + '/group';
    },
    PUT_BOND_INTERFACE: (interfaceId: string): string => {
        return '/interfaces/' + interfaceId;
    },
    DELETE_BOND_INTERFACE: (interfaceId: string): string => {
        return '/interfaces/' + interfaceId;
    }
};
